import request from './request'

export const getShopReferrerShopList = (params) => {
  return request({
    url: '/admin/shop-referrer-shops',
    method: 'get',
    params
  })
}

export const getShopReferrerShopDetail = (id) => {
  return request({
    url: `/admin/shop-referrer-shops/${id}`,
    method: 'get'
  })
}

export const createShopReferrerShop = (data) => {
  return request({
    url: '/admin/shop-referrer-shops',
    method: 'post',
    data
  })
}

export const updateShopReferrerShop = (id, data) => {
  return request({
    url: `/admin/shop-referrer-shops/${id}`,
    method: 'put',
    data
  })
}

export const deleteShopReferrerShop = (id) => {
  return request({
    url: `/admin/shop-referrer-shops/${id}`,
    method: 'delete'
  })
}
